export default __webpack_public_path__ + "static/media/Shin-straps of the Death Master (nm).38e1d8fd.jpg";